const riot = require('riot');

riot.tag2('atom-distribution_event_csv_job_status-badge', '<div data-is="atom-badge" text="{getText(opts.item.status)}" classes="{getClasses(opts.item.status)}"></div>', 'atom-distribution_event_csv_job_status-badge,[data-is="atom-distribution_event_csv_job_status-badge"]{display:inline-block}', '', function(opts) {

    this.getText = (status) => {
      const isRaffle = this.opts.item.distribution_target_strategy?.distribution_target_type !== 'all';
      let currentStatus;

      if (isRaffle) {
        currentStatus = app.data.constants.raffle_event_csv_job_statuses.find(s => s.id === status);
      }
      else {
        currentStatus = app.data.constants.distribution_event_csv_job_statuses.find(s => s.id === status);
      }

      return currentStatus.name;
    };

    this.getClasses = (status) => {
      return {
        'in_progress': 'text-green_60 bg-green_05 border-green_40',
        'complete': 'text-white bg-green_60',
        'failed': 'text-white bg-red_70',
      }[status];
    };
});